<template>
  <el-container class="container" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
    <!-- 主要内容容器 -->
    <el-container style="position:relative;height:100%">
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="height: 60px;background: white;display: flex;justify-content: space-between;align-items: flex-end;">
        <div></div>
        <CustomTool style="width:120px;" :column_mapper="column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="true" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="exportExcel"/>
      </el-header>
      <div style="height: 100%;width:100%;box-sizing: border-box;padding:20px 0px;overflow: scroll;background:white;">
        <!--
        //列表相关
        @row-click 点击列表某个item事件
        project-list-dl 表格列表内容

        //列和表头相关
        @column-drop 表头拖动排序事件
        show-coloums-dl 显示的列（即表头显示的）
        column_mapper 所有的列枚举（包含未在表头显示的）

        //排序相关
        @sort-change 排序变化事件
        sort-column-name-dl 排序的名称
        sort-column-order-dl 排序的规则

        //页面控制相关
        @current-change  当前页改变事件
        totalnums-dl 总页数
        pagesize-dl 每页页数
        page-number-dl 当前页

        //表头固定
        fixed-columns
        -->
        <custom-table
            ref="mytable"
            :table-id="4"
            @row-click="rowClick"
            :project-list-dl="tableData.projectList"

            :show-coloums-dl="tableData.showColoums"
            :column_mapper="tableData.column_mapper"

            @sort-change="sortChange"
            :sort-column-name-dl="tableData.sortColumnName"
            :sort-column-order-dl="tableData.sortColumnOrder"

            @current-change="currentChange"
            :totalnums-dl="tableData.totalnums"
            :pagesize-dl="tableData.pagesize"
            :page-number-dl="tableData.pageNumber"

            :fixed-columns="tableData.fixedList"

            :disableDrag="true"

            :sortable="true"

            :pagination="tableData.pagination"

            :is-loading-dl="tableData.detailLoading"
            :use-virtual="false"
            :row-hegit="0"

            :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
            @unusualShow="unusualShow"
            :custom-tabel-height-offset="265"
        ></custom-table>
      </div>
      <CustomDialog v-model="dialogFormVisible" :filterRequestData="dialogRequestData" :column_mapper="column_mapper"></CustomDialog>

    </el-container>
  </el-container>
</template>

<script>
import CustomTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/PrePayManage/dialog/CustomDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import {
  exportAdvance,
  getUnusualList, getAdvance
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
export default {
  name: "PrePayManage",
  props:["refreshId"],
  components:{
    CustomTable,
    CustomTool,
    CustomCard,
    CustomDialog,
    LeftBar
  },
  data(){
    return {
      column_mapper:{
        "advance_name":"预付款名称:like",
        "stat_time":"结算日期:date",
        "client_name": "客户:varchar",
        "invoice_id": "开票编号:varchar"
      },

      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "预付款",
          key: "advance"
        }
      ],
      currentSelectLeftItemKey:"advance",


      dialogFormVisible:false,
      filterRequestData:{},
      dialogRequestData:{
        invoice_id:""
      },
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      filterArchiveData:{
        start_end_date_dynamic:[],
        queryCond: []
      },

      showTimeArea:true
    }
  },
  async mounted() {
    window.vm4 = this
    this.refresh()
  },

  watch:{
    refreshId(newVal){
      // console.log('refreshId change,刷新todoList',newVal)
      this.refresh(false)
    },
  },

  methods:{
    filterContentChange(content){
      // console.log('filterContentChange',content)
      Object.assign(this.filterContent,content)
      this.refresh()
      // this.getPerformanceData()
    },

    async exportExcel(){
      let param = {
        division:this.currentSelectLeftItemKey
      }
      // console.log('exportFinancial/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportAdvance(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let fileName = this.leftItems.find(i=>i.key==this.currentSelectLeftItemKey).name + '-' + Y + M + D + H + m + s + ".xlsx"

        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async unusualShow(project_id){
      let res = await getUnusualList({project_id: project_id})
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.tableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.tableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      this.dialogRequestData = e
      this.dialogFormVisible = true
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
    },
    sortChange(e) {
      // console.log('sortChange',e)

      if (e.order === null) {
        this.filterContent.sortCond.columnName = ""
        this.filterContent.sortCond.value = ""
      } else {
        this.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.filterContent.sortCond.value = 'asc'
        } else {
          this.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },

    async currentChange(e) {
      // console.log('currentChange',e)
      this.tableData.pageNumber = e;
      this.refresh(false)
    },

    shourtcutSelectChange(key){
      this.contentMap[this.currentSelectLeftItemKey].selectShortcutId = key
      this.refresh()
    },

    leftItemselectChange(key){
      // console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      this.refresh()
    },



    async getData(resetPage=false){
      if(resetPage){
        this.tableData.pageNumber = 1
      }

      this.filterRequestData = {
        division:this.currentSelectLeftItemKey,
        pagiInfo: {
          currentPage: this.tableData.pageNumber,
          pagesize: this.tableData.pagesize
        },
        ...this.filterContent
      }
      let postData = this.filterRequestData
      // console.log('postData', postData)
      let res = await getAdvance(postData)
      let resData = res.data
      const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
      // console.log('返回结果', resData,cols_mapper,data,columns_list)
      this.tableData.column_mapper = cols_mapper
      this.tableData.projectList = data
      this.tableData.totalnums =  totalnums
      this.tableData.showColoums = columns_list
      // console.log('this.tableData.showColoums',this.tableData.showColoums )


      this.$nextTick(() => {
        this.tableData.detailLoading = false
      })



    },

    async refresh(resetPage=true){
      this.tableData.detailLoading = true
      await this.getData(resetPage)
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

